import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './Slider.css';
import { FaEye, FaRegCalendarAlt } from 'react-icons/fa';

const Slider = ({ data }) => {
  const navigate = useNavigate();

  if (!data || data.length === 0) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <div className="loader-text">Loading trending blogs...</div>
      </div>
    );
  }

  return (
    <div className="trending-slider">
      <h2 className="slider-title">Trending Blogs</h2>
      <Swiper
        spaceBetween={20}
        slidesPerView={4}
        loop={true}
        navigation={true}
        modules={[Autoplay, Navigation]}
        effect="fade"
        speed={1000}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: { slidesPerView: 1 },
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 4 },
        }}
      >
        {data.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="news-card" onClick={() => navigate(`/blog/${item.slug}`)}>
              <img
                src={`https://api.funfillia.com/${item.image_500x500}`}
                alt={item.title}
                title={item.title}
                className="news-img"
              />
            <span className="news-tag dark-tag" style={{ marginTop: '20px' }}>
             {item.category?.name || 'Category'}
            </span>


              <h4 className="news-title">{item.title}</h4>
              <p className="news-meta">
                <FaRegCalendarAlt/> {new Date(item.published_at).toLocaleDateString()} &nbsp;&nbsp;
                <FaEye/> {item.views_count} views
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Slider;
